import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthRequestDto } from '../../shared/models/auth/auth-request-dto';
import { AuthResponseDto } from '../../shared/models/auth/auth-response-dto';
import { Router } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { ThemingService } from '@michelin/theme';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationModuleService } from '../../shared/services/application-module/application-module.service';
import { ApplicationModuleDTO } from '../../shared/models/application-module/application-module';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { AccessLogUtil } from 'src/app/shared/utils/acess-log-util';
import packageInfo from '../../../../package.json';

@Component({
    templateUrl: 'login.component.html',
    host: { 'collision-id': 'LoginComponent' },
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  public version: string = packageInfo.version;
  public releaseDate: string = (packageInfo as any).release;
  hide = true;

  image = false;

  form: FormGroup;

  @HostBinding('class') className = this.themingService.theme.className;

  hideAllAlerts: boolean = true;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private readonly themingService: ThemingService,
    private readonly alertService: AlertService,
    private translate: TranslateService,
    private applicationModuleService: ApplicationModuleService,
    private dialog: MatDialog,
    private accessLogUtil: AccessLogUtil
  ) {
    this.form = this.fb.group({
      username: [],
      password: []
    });
  }

  ngOnInit(): void {
    console.log('LoginComponent INIT');
  }

  toUpperCase(event: Event): void {
    const input = event.target as HTMLInputElement;
    const upperValue = input.value.toUpperCase();
    input.value = upperValue;

    this.form.get('username')?.setValue(upperValue, { emitEvent: false });
  }

  public login() {
    const savedLanguage = localStorage.getItem('language');
    localStorage.clear();
    if (savedLanguage) {
      localStorage.setItem('language', savedLanguage);
    }

    if (!this.form.valid) {
      this.showAlert(AlertType.strong, this.translate.instant('app.feedback.formInvalid'));
      return;
    }

    let username = this.form.get('username').value;
    let password = this.form.get('password').value;

    this.authService.authenticate(new AuthRequestDto(username, password)).subscribe({
      next: (data: AuthResponseDto) => {
        this.authService.setAuthentication(data);

        // Wait to load permissions before browsing
        this.applicationModuleService.getByUserId(username).subscribe({
          next: (permissions: ApplicationModuleDTO[]) => {
            localStorage.setItem(environment.keyPermissions, JSON.stringify(permissions));

            // Now permissions have been saved
            this.router.navigate(['/home']);
          },
          error: (error) => console.log(error)
        });

        this.accessLogUtil.accessLog('00_00', '00_00_00');

        if (this.authService.isResetPassword()) {
          this.dialog.open(ChangePasswordComponent, {
            width: '40rem',
            height: '35rem',
            disableClose: true,
            autoFocus: false
          });
        }
      },
      error: (error) => {
        console.log('ERROR RESPONSE', error);

        if (error.status === 401) {
          // Erro de autenticação (usuário ou senha inválidos)
          this.translate.get('app.feedback.loginFailed').subscribe((translatedMessage) => {
            setTimeout(() => {
              this.hideAllAlerts = false;
              this.showAlert(AlertType.strong, translatedMessage, 'Warning');
            }, 0);
          });
        } else {
          // Qualquer outro erro
          this.translate.get('app.feedback.error').subscribe((translatedMessage) => {
            setTimeout(() => {
              this.hideAllAlerts = false;
              this.showAlert(AlertType.strong, translatedMessage, 'Error');
            }, 0);
          });
        }
      }
    });
  }

  private setPermissions(username: string) {
    this.applicationModuleService.getByUserId(username).subscribe({
      next: (data: ApplicationModuleDTO[]) => {
        localStorage.setItem(environment.keyPermissions, JSON.stringify(data));
      },
      error: (error) => console.log(error)
    });
  }

  showAlert(type: AlertType, content: string, title: string = '') {
    this.alertService.showAlert({
      type: type,
      content: content,
      title: title
    } as Alert);
  }
}
